define([
    "./intlPhoneNumberModule",
    "./nlgIntlPhoneNumber",
    "./countryLanguages",
    "./ngIntlTelInputConfiguration"
], function () {
});